import { NavLink } from 'react-router-dom'

import { NAVIGATION_TARGET_BLANK } from '../constants/externalResources'

const buildLinkParams = ({ isOutside, href }) => {
  if (href) {
    return isOutside
      ? {
          href,
          target: NAVIGATION_TARGET_BLANK,
          rel: 'noopener noreferrer',
          component: 'a'
        }
      : { component: NavLink, to: href }
  }
  return ''
}

export { buildLinkParams }
